/* eslint no-lonely-if: "off" */
import Vue from 'vue';
import Vuex from 'vuex';
import _ from 'lodash';
import Contacts from '@/store/modules/Contacts';
import Traffic from '@/components/cards/Traffic.vue';
// import Handoff from '@/components/cards/Handoff.vue';
import ips from '@/components/cards/ips.vue';
import IpjForm from '@/components/subforms/IpjForm.vue';
import OutletType from '@/components/cards/OutletType.vue';
import PRIQuestions from '@/components/subforms/PRIQuestions.vue';
import LetterOfAgency from '@/components/subforms/LetterOfAgency.vue';
import NewNumbers from '@/components/cards/NewNumbers.vue';
// import RespOrg from '@/components/subforms/RespOrg.vue'; (can delete)
// import WhitePageListingForm from '@/components/subforms/WhitePageListingForm.vue'; (can delete)
// import CallerID from '@/components/cards/CallerID.vue'; (can delete)
// import E911 from '@/components/cards/E911.vue'; (can delete)
import EmergFailoverDest from '@/components/cards/EmergFailoverDest.vue';
// import Notes from '@/components/cards/Notes.vue';
import IntlCanada from '@/components/cards/InternationalCanadaCalling.vue';
import VLAN from '@/components/cards/VLAN.vue';
// import ReviewProduct from '@/components/cards/ReviewProduct.vue';

import AdditionalInfoApi from '../apis/api';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  state: {
    readyToSign: false,
    globalLoad: false,
    contractId: null,
    accessKey: null,
    companyName: null,
    companyId: null,
    companyHandle: null,
    company: {},
    errorData: {},
    user: {
      isAuthenticated: false,
    },
    currentMainTab: 'additionalInfo',
    currentSubTab: 'rdd',
    formData: {},
    helpContact: null,
    straightFactsNoPrinter: {},
    currentProductId: null,
    products: [],
    stepperFunction: null,
    globalAddresses: [],
    allFiles: [],
    onePersonRoles: {
      'PBX Vendor': true,
      'IT Vendor': true,
      'State Tax Exemption Contact': true,
      'MI911 Fee Exemption Contact': true,
    },
    provisions: [
      { label: 'CHARGES PAID BY GOVERNMENTAL TAX EXEMPT ORGANIZATION', value: 'government' },
      { label: 'NONPROFIT EDUCATIONAL ORGANIZATION', value: 'nonprofit_educational' },
      { label: 'SCHOOLS OPERATED AS AN ACTIVITY OF A CHURCH, PARISH OR OTHER RELIGIOUS BODY', value: 'religious_school' },
      { label: 'NONPROFIT HOSPITAL', value: 'nonprofit_hospital' },
      { label: 'COMMON CARRIER, TELEPHONE AND TELEGRAPH COMPANY, RADIO AND TELEVISION BROADCASTING STATIONS AND NETWORKS', value: 'telecom' },
      { label: 'COMMUNICATIONS SERVICES USED AS COMPONENTS OF A TAXABLE SERVICE', value: 'taxable_component' },
      { label: 'NEWS SERVICES', value: 'news_service' },
      { label: 'CONSULAR OFFICER OF THE GOVERNMENT OF ___', value: 'foreign' },
      { label: 'NO LONGER ENTITLED TO TAX EXEMPTION EFFECTIVE ___', value: 'not_exempt' },
    ],
  },

  // Use me to directly change the state
  mutations: {
    SET_GLOBAL_LOAD(state, param) {
      state.globalLoad = param;
    },
    SET_READY_TO_SIGN_STATUS(state, status) {
      state.readyToSign = status;
    },
    setFormData(state, params) {
      state.contractId = params.contractId;
      state.accessKey = params.accessKey;
      state.formData = params.data.info;
      const info = params.data.info.general || {};
      if (info.current_main_tab != null) {
        state.currentMainTab = info.current_main_tab;
      }
      if (info.current_sub_tab != null) {
        state.currentSubTab = info.current_sub_tab;
      }
      if (info.current_product_id != null) {
        state.currentProductId = info.current_product_id;
      }
      state.helpContact = params.data.helpContact;
      state.products = params.data.products;
      state.straightFactsNoPrinter = params.data.quote_facts_no_printer;
      state.companyName = params.data.quote_facts_no_printer.company_name;
      state.companyId = params.data.quote_facts_no_printer.company_id;
      state.companyHandle = params.data.quote_facts_no_printer.company_handle;
      state.company = params.data.company_data;
    },
    setError(state, data) {
      state.errorData = data;
    },
    SET_TAB(state, payload) {
      if (payload.level === 'main') state.currentMainTab = payload.tab;
      if (payload.level === 'sub') state.currentSubTab = payload.tab;
    },

    UPDATE_STORE_FORM_DATA(state, obj) {
      if (state.formData[obj.main] == null) {
        Vue.set(state.formData, obj.main, {});
      }
      Vue.set(state.formData[obj.main], obj.sub, obj.data);
    },

    SYNC_FORM_DATA(state, payload) {
      // Many components watch changes and sync all changes back to
      // the store. If you update the contacts in the contacts component,
      // unless you simultaneously watch the store, your code when syncing
      // will overwrite the contacts stuff every time.
      // I added this to prevent that, if updating contacts stuff don't use
      // the sync sub.
      // In the future we should probably rip contacts right out of formData altogether
      // It should be separate and not part of hideousExport
      if (payload.mainKey === 'general') {
        payload.data.contacts = state.formData.general.contacts;
      }
      Vue.set(state.formData, payload.mainKey, payload.data);
    },

    SET_CURRENT_PRODUCT_ID(state, productId) {
      state.currentProductId = productId;
      const product = _.find(state.products, { product_id: productId });
      if (product.form_status == null || product.form_status === 'not_started') {
        product.form_status = 'in_progress';
      }
      if (state.formData[productId] == null) {
        Vue.set(state.formData, productId, {});
      }
    },

    RESET_CURRENT_PRODUCT_ID(state) {
      state.currentProductId = null;
    },

    HIJACK_STEPPER(state, customFunction) {
      state.stepperFunction = customFunction;
    },
    SET_GLOBAL_ADDRESSES(state, addresses) {
      state.globalAddresses = addresses;
    },

    APPEND_FILES(state, moreFiles) {
      Vue.set(state, 'allFiles', _.unionBy(state.allFiles, moreFiles, 'fileId'));
    },

    ADD_CONTACT_IDS(state, newContacts) {
      newContacts.forEach((newContact) => {
        state.formData.general.contacts[newContact.idx].row_id = newContact.row_id;
      });
    },

    UPDATE_CONTACT(state, data) {
      Vue.set(state.formData.general.contacts[data.idx], 'first', data.updatedContact.first);
      Vue.set(state.formData.general.contacts[data.idx], 'last', data.updatedContact.last);
      Vue.set(state.formData.general.contacts[data.idx], 'email', data.updatedContact.email);
      Vue.set(state.formData.general.contacts[data.idx], 'phone', data.updatedContact.phone);
      Vue.set(state.formData.general.contacts[data.idx], 'title', data.updatedContact.title);
      Vue.set(state.formData.general.contacts[data.idx], 'roles', data.updatedContact.roles);
      Vue.set(state.formData.general.contacts[data.idx], 'company', data.updatedContact.company);
      Vue.set(state.formData.general.contacts[data.idx], 'address', data.updatedContact.address);
      Vue.set(state.formData.general.contacts[data.idx], 'pin', data.updatedContact.pin);
      Vue.set(state.formData.general.contacts[data.idx], 'ordernumber', data.updatedContact.ordernumber);
    },

    ADD_CONTACT(state, contact) {
      state.formData.general.contacts.unshift(contact);
    },

    DELETE_ROLE(state, data) {
      _.forEach(state.formData.general.contacts, (contact, i) => {
        if (i !== data.preserveOn) {
          const roleIdx = _.findIndex(contact.roles, (role) => role === data.role);
          if (roleIdx !== -1) {
            contact.roles.splice(roleIdx, 1);
          }
        }
      });
    },
  },

  // functions called throughout the app that call mutations
  actions: {
    hijackStepper({ commit }, customFunction) {
      commit('HIJACK_STEPPER', customFunction);
    },

    unHijackStepper({ commit }) {
      commit('HIJACK_STEPPER', null);
    },

    setCurrentProductId({ commit, getters, dispatch }, productId) {
      commit('SET_CURRENT_PRODUCT_ID', productId);
      const subTabs = getters.productSubTabs();
      dispatch('setSubTab', subTabs[0].id);
    },

    setMainTab(ctx, tab) {
      ctx.commit('SET_TAB', {
        tab,
        level: 'main',
      });
      if (tab === 'additionalInfo') {
        ctx.commit('SET_TAB', {
          tab: 'rdd',
          level: 'sub',
        });
      }
      ctx.dispatch('saveProgress');
      ctx.commit('RESET_CURRENT_PRODUCT_ID');
    },

    setReadyToSignStatus({ commit }, status) {
      commit('SET_READY_TO_SIGN_STATUS', status);
    },

    setGlobalLoad({ commit }, param) {
      commit('SET_GLOBAL_LOAD', param);
    },

    async loadForm(context, { contractId, accessKey }) {
      context.dispatch('setGlobalLoad', true);
      try {
        const response = await AdditionalInfoApi.get(`${contractId}/${accessKey}`);
        context.commit('setFormData', { contractId, accessKey, data: response.data });
      } catch (e) {
        context.commit('setError', { code: e.response.status, message: e.response.data.status, data: e.response.data });
        throw new Error(e);
      } finally {
        context.dispatch('setGlobalLoad', false);
      }
    },

    setSubTab(context, tab) {
      context.commit('SET_TAB', {
        tab,
        level: 'sub',
      });
      context.dispatch('saveProgress', tab);
      return tab;
    },

    nextSubTab(context, goRight) {
      if (context.state.stepperFunction != null) {
        context.state.stepperFunction(goRight);
        return { status: true };
      }
      let tabs = [];
      const currentTab = context.state.currentSubTab;
      if (context.state.currentMainTab === "additionalInfo") {
        tabs = context.getters.addInfoSubTabs;
      } else {
        tabs = context.getters.productSubTabs();
      }
      let currentIndex = _.findIndex(tabs, { id: currentTab });
      if (goRight === true) {
        currentIndex += 1;
      } else {
        currentIndex -= 1;
      }
      let nextTab = tabs[currentIndex];
      if (nextTab != null) {
        if (goRight === true && context.state.currentMainTab === "additionalInfo") {
          // canGoToTab returns { status, reason }
          const permission = context.getters.canGoToTab(nextTab.id);

          if (!permission?.status) {
            return {
              status: true,
              reason: permission?.reason,
            };
          }
        }
        context.dispatch('setSubTab', nextTab.id);
      } else {
        currentIndex = context.getters.currentMainTabIndex;
        if (goRight && context.state.currentMainTab !== "products") {
          nextTab = context.getters.mainTabs[currentIndex + 1];
          context.dispatch('setMainTab', nextTab.value);
        } else if (context.state.currentMainTab === "products") {
          context.dispatch('updateStoreFormData', {
            data: 'completed',
            main: context.getters.getProductIdSelected,
            sub: 'product_status',
          });
          // check to see if all products status are set to complete
          const uncompleted = context.getters.getProducts.filter((product) => context.getters.getFormData[product.product_id]?.product_status !== 'completed');
          if (uncompleted.length === 0) {
            context.dispatch('setMainTab', "review");
          }
          context.commit('RESET_CURRENT_PRODUCT_ID');
          context.dispatch('setSubTab', null);
        }
      }
      return { status: true };
    },

    updateStoreFormData({ commit }, obj) {
      commit('UPDATE_STORE_FORM_DATA', obj);
    },

    syncFormData(context, payload) {
      // const mergedData = _.merge({}, context.state.formData[payload.mainKey], payload.data);
      context.commit('SYNC_FORM_DATA', {
        mainKey: payload.mainKey,
        data: payload.data,
      });
    },

    updateNewNumbersField({ getters, commit }) {
      const productInfo = getters.getProductInfo();
      const { porting } = productInfo;
      const newNumbersRequested = productInfo.new_numbers_requested;
      const payload = {
        main: getters.getProductIdSelected,
        sub: 'new_numbers',
      };
      if (porting == null || newNumbersRequested == null) {
        payload.data = null;
      }
      if (porting === 'y') {
        if (newNumbersRequested === 'y') {
          payload.data = 'y_port';
        } else {
          payload.data = 'n_port';
        }
      } else {
        if (newNumbersRequested === 'y') {
          payload.data = 'y_noport';
        } else {
          payload.data = 'n';
        }
      }
      commit('UPDATE_STORE_FORM_DATA', payload);
    },

    async saveProgress(context) {
      context.dispatch('setGlobalLoad', true);
      try {
        const response = await AdditionalInfoApi.post(`${context.state.contractId}/${context.state.accessKey}`, context.getters.hideousExport);
        const newContacts = response.data.new_contacts;
        if (newContacts.length > 0) {
          context.commit('ADD_CONTACT_IDS', newContacts);
        }
        return response.data;
      } catch (e) {
        context.commit('setError', { code: e.response.status, message: e.response.data.status, data: e.response.data });
        throw new Error(e);
      } finally {
        context.dispatch('setGlobalLoad', false);
      }
    },
    async fetchGlobalAddressList({ commit, state }) {
      try {
        const params = {
          contract_id: state.contractId,
          company_id: state.companyId,
          company_handle: state.companyHandle,
        };
        const res = await AdditionalInfoApi.get(`${state.contractId}/${state.accessKey}/get_global_addresses`, { params });
        commit('SET_GLOBAL_ADDRESSES', res.data);
      } catch (e) {
        commit('setError', { code: e.response.status, message: e.response.data.status, data: e.response.data });
        throw new Error(e);
      }
    },

    async uploadFiles({ state, commit }, { uploadedFiles, tags }) {
      try {
        tags.contract_id = state.contractId;
        tags.product_id = state.currentProductId;
        const formData = new FormData();
        formData.append('tags', JSON.stringify(tags));
        for (let i = 0; i < uploadedFiles.length; i += 1) {
          formData.append('file', uploadedFiles[i]);
        }
        const response = await AdditionalInfoApi.post(`${state.contractId}/${state.accessKey}/upload_files`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        commit('APPEND_FILES', response.data.saved);

        return response.data;
      } catch (e) {
        commit('setError', { code: e.response.status, message: e.response.data.status, data: e.response.data });
        throw new Error(e);
      }
    },
    async fetchFiles({ state, commit }) {
      try {
        let endpoint = `${state.contractId}/${state.accessKey}/get_files`;
        if (state.currentProductId != null) {
          endpoint += `/${state.currentProductId}`;
        }
        const response = await AdditionalInfoApi.get(endpoint);
        commit('APPEND_FILES', response.data);
      } catch (e) {
        commit('setError', { code: e.response.status, message: e.response.data.status, data: e.response.data });
        throw new Error(e);
      }
    },

    updateContactStore(context, contact) {
      const theContactIdx = _.findIndex(
        context.getters.contactsList,
        { fullname: contact.fullname },
      );
      _.forEach(contact.roles, (role) => {
        if (context.state.onePersonRoles[role]) {
          context.commit('DELETE_ROLE', { preserveOn: theContactIdx, role });
        }
      });
      if (theContactIdx === -1) {
        context.commit('ADD_CONTACT', contact);
      } else {
        context.commit('UPDATE_CONTACT', { idx: theContactIdx, updatedContact: contact });
      }
    },
  },

  getters: {
    getProvisions(state) {
      return state.provisions;
    },
    contactsList(state) {
      return state.formData.general.contacts;
    },
    hideousExport(state) {
      const data = {
        row_id: state.contractId,
      };
      _.each(state.formData, (value, key) => {
        let autoKey = `_${key}`;
        if (key === 'general') {
          autoKey = '';
        }
        _.each(value, (v, k) => {
          if (_.isArray(v) && k !== 'contacts') {
            _.forEach(v, (finalvalue, finalkey) => {
              data[`${k}${autoKey}_${finalkey}`] = finalvalue;
            });
          } else {
            data[k + autoKey] = v;
          }
        });
      });
      data.current_main_tab = state.currentMainTab;
      data.current_sub_tab = state.currentSubTab;
      data.current_product_id = state.currentProductId;
      return data;
    },
    getGlobalLoadStatus(state) {
      return state.globalLoad;
    },
    errorData(state) {
      return state.errorData.data;
    },
    errorMessage(state) {
      return state.errorData.message;
    },
    getTabs(state) {
      return { main: state.currentMainTab, sub: state.currentSubTab };
    },
    getSubTab(state, getters) {
      const tabs = getters.getTabs;
      let subTabs = [];
      if (tabs.main === 'additionalInfo') {
        subTabs = getters.addInfoSubTabs;
      } else if (tabs.main === 'products' && state.currentProductId != null) {
        subTabs = getters.productSubTabs();
      }
      if (subTabs.length > 0) {
        return _.find(subTabs, { id: tabs.sub });
      }
      return {};
    },
    getFormData(state) {
      return state.formData;
    },
    getCompanyData(state) {
      return state.company;
    },
    getUsfQuestionResponse(state) {
      return state.formData.general.usf_charge;
    },
    getMiAccessChargesResponse(state) {
      return state.formData.general.stateaccess_charge;
    },
    getProductIdSelected(state) {
      return state.currentProductId;
    },
    getProductSelected(state) {
      return _.find(state.products, { product_id: state.currentProductId }) || {};
    },
    getProducts(state) {
      return state.products;
    },
    getCompanyAddress(state) {
      return {
        streetAddress: state.formData.general.street_address,
        suite: state.formData.general.suite,
        city: state.formData.general.city,
        state: state.formData.general.state,
        zip: state.formData.general.zip,
      };
    },
    productSpeed: (state, getters) => (product = getters.getProductSelected) => {
      // const product = getters.getProductSelected;
      const speedAttribute = _.find(product.attributes, { attribute: 'speed' }) || {};
      const speed = parseFloat(speedAttribute.value);
      return speed;
    },
    productEcf: (state, getters) => (product = getters.getProductSelected) => {
      const ecfAddon = _.find(product.addons, { item_code: 'ecf' });
      return (ecfAddon?.value || "no");
    },
    productIps: (state, getters) => (product = getters.getProductSelected) => {
      // const product = getters.getProductSelected;
      const ipsAddon = _.find(product.addons, { item_code: 'ips' });
      return (ipsAddon || {}).quantity;
    },
    currentIPs: (state, getters) => (product = getters.getProductSelected) => {
      const productInfo = getters.getProductInfo(product.product_id);
      if (productInfo.ips == null) {
        return getters.productIps(product);
      }
      return productInfo.ips;
    },
    mainTabs(state, getters) {
      if (getters.getProducts.some((product) => getters.productSubTabs(product).length > 1)) {
        return [
          { value: "additionalInfo", name: "Additional Info" },
          { value: "products", name: "Products" },
          { value: "review", name: "Review" },
          // { value: "signAndSubmit", name: "Submit" },
        ];
      }
      return [
        { value: "additionalInfo", name: "Additional Info" },
        { value: "review", name: "Review" },
        // { value: "signAndSubmit", name: "Submit" },
      ];
    },
    addInfoSubTabs(state, getters) {
      const tabs = [
        { name: "Requested Due Date", id: "rdd" },
        { name: "Tax Questions", id: "tax_qs" },
      ];
      // if (getters.getUsfQuestionResponse === 'exempt') {
      //   tabs.push({
      //     name: 'USF Form',
      //     id: 'usf_form',
      //   });
      // }
      // if (getters.getMiAccessChargesResponse === 'exempt') {
      //   tabs.push({
      //     name: 'MI Access Charges Form',
      //     id: 'mi_access_charges',
      //   });
      // }
      // if (getters.getQuoteInfo.statetax === 'exempt') {
      //   tabs.push({
      //     name: 'State Tax Form',
      //     id: 'statetax_form',
      //   });
      // }
      // if (getters.getQuoteInfo.fedtax === 'exempt') {
      //   tabs.push({
      //     name: 'Federal Excise Tax Form',
      //     id: 'fed_form',
      //   });
      // }
      // if (getters.getQuoteInfo.emergency_fee === 'exempt') {
      //   tabs.push({
      //     name: 'MI911 Fee Form',
      //     id: 'mi911_form',
      //   });
      // }
      tabs.push(
        { name: "Manage Contacts", id: "contacts" },
      );
      // tabs.push(
      //   { name: "[legacy] Billing Info", id: "ap_billing" },
      // );
      if (getters.isRetail) {
        // tabs.push(
        //   { name: "[legacy] IT Vendor Info", id: "vendor_info" },
        // );

        // tabs.push(
        //   { name: "[legacy] PBX Vendor Info", id: "pbx_vendor_info" },
        // );
      }
      // tabs.push(
      //   { name: "Review", id: "review" },
      // );
      return tabs;
    },
    productSubTabs: (state, getters) => (product = getters.getProductSelected) => {
      const tabs = [];

      if (getters.productSpeed(product) > 0 && product.order_type !== 'ptp') {
        // tabs.push({
        //   name: 'Handoff',
        //   id: 'handoff',
        //   component: Handoff,
        // });
      }

      if (product.order_type === 'dia' && getters.productIps(product) !== "" && getters.productIps(product) !== 0 && getters.currentIPs(product) >= 253) {
        tabs.push({
          name: 'IP Addresses',
          id: 'ips',
          component: ips,
        });
      }

      /* ***
        IP reference:
          { length: '/30', amount: '1', mrc: 'No Charge' },
          { length: '/29', amount: '5', mrc: '$10.00' },
          { length: '/28', amount: '13', mrc: '$20.00' },
          { length: '/27', amount: '29', mrc: '$40.00' },
          { length: '/26', amount: '61', mrc: '$80.00' },
          { length: '/25', amount: '125', mrc: '$160.00' },
          { length: '/24', amount: '253', mrc: '$300.00' },
      *** */

      // AIF-91: update amount
      // console.log(getters.currentIPs(product));
      if (getters.currentIPs(product) >= 253) {
        tabs.push({
          name: 'IP Justification Form',
          id: 'ipj_form',
          component: IpjForm,
        });
      }
      /* ********* voice ******* */
      if (product.is_voice === 1) {
        if (product.order_type === 'pri' || product.order_type === 'dpri') {
          tabs.push({
            name: 'PRI Questions',
            id: 'pri_questions',
            component: PRIQuestions,
          });
        }

        tabs.push({
          name: 'Letter of Agency',
          id: 'loa',
          component: LetterOfAgency,
        });

        tabs.push({
          name: 'New Numbers',
          id: 'new_numbers',
          component: NewNumbers,
        });

        // tabs.push({
        //   name: 'Toll Free Change Request',
        //   id: 'resp_org',
        //   component: RespOrg,
        // });

        // tabs.push({
        //   name: 'White Page Listing',
        //   id: 'wpl_form',
        //   component: WhitePageListingForm,
        // });

        // tabs.push({
        //   name: 'Caller ID',
        //   id: 'caller_id',
        //   component: CallerID,
        // });

        // tabs.push({
        //   name: '911 Address',
        //   id: 'e911',
        //   component: E911,
        // });

        if (getters.productEcf(product) === 'yes' || getters.productEcf(product) === 'y') {
          tabs.push({
            name: 'Emergency Failover Destination',
            id: 'emerg_failover_dest',
            component: EmergFailoverDest,
          });
        }

        tabs.push({
          name: 'International Calling',
          id: 'international_canada_calling',
          component: IntlCanada,
        });

        // tabs.push({
        //   name: 'Notes',
        //   id: 'loa_notes',
        //   component: Notes,
        // });
      }
      /* ********* voice ******* */

      if (product.order_type === 'evpl' && !getters.isRetail) {
        tabs.push({
          name: 'VLAN Preference',
          id: 'vlan',
          component: VLAN,
        });
      }

      if (product.order_type === 'ptp' || product.order_type === 'evpl') {
        tabs.push({
          name: 'Traffic Designation',
          id: 'traffic_type',
          component: Traffic,
        });
      }

      if (product.order_type === 'col') {
        product.addons.forEach((addon) => {
          if (addon.item_code === 'power' && addon.value !== '50ADC') {
            tabs.push({
              name: `${addon.name.substring(7)} Outlet Type`,
              id: `outlet_type_${addon.nth}`,
              component: OutletType,
            });
          }
        });
      }
      // if (tabs.length > 0) {
      //   if (product.order_type !== 'evpl' && product.order_type !== 'ptp' && product.order_type !== 'ucaas' && product.order_type !== 'fax' && product.order_type !== 'dpri' && product.order_type !== 'dvd' && product.order_type !== 'hosted' && product.order_type !== 'pots' && product.order_type !== 'sip' && product.order_type !== 'vdt1' && product.order_type !== 'vt1' && product.order_type !== 'pri') {
      //     tabs.push({
      //       name: 'Review',
      //       id: 'review',
      //       component: ReviewProduct,
      //     });
      //   }
      // }
      return tabs;
    },
    canGoBack(state) {
      if (state.currentMainTab === "additionalInfo" && state.currentSubTab === 'rdd') {
        return false;
      }
      return true;
    },
    canGoForward(state, getters) {
      // review / validation
      // console.log(`can go forward state. ->>${JSON.stringify(state.formData)}`);
      // console.log(`tab id ${state.currentSubTab}`);
      if (state.currentSubTab === "rdd" && (state.general?.has_due_date && !(state.general.requested_due_date))) {
        return false;
      }

      if (state.currentSubTab === "contacts") {
        const contactValidation = getters.validateContacts;
        return contactValidation.status;
      }
      // state.formData["requested_due_data"]
      if (getters.currentMainTabIndex > 1) {
        return false;
      }
      return true;
    },
    currentMainTabIndex(state, getters) {
      return _.findIndex(getters.mainTabs, { value: state.currentMainTab });
    },
    getProductInfo: (state, getters) => (id = getters.getProductIdSelected) => {
      const info = state.formData[id] || {};
      return info;
    },
    getQuoteInfo(state) {
      return state.formData.general || {};
    },
    getQuoteFacts(state) {
      return state.straightFactsNoPrinter;
    },
    getGlobalAddressList(state) {
      const addresses = state.globalAddresses.map((address, idx) => {
        address.idx = idx;
        return address;
      });
      return addresses;
    },
    getAllFiles(state) {
      return state.allFiles;
    },
    isReady(state) {
      return state.readyToSign;
    },
    isCompleted(state) {
      return state.formData.general?.completed != null;
    },
    isExistingCustomer(state) {
      return state.companyHandle != null;
    },
    isRetail(state) {
      const companyType = state.straightFactsNoPrinter.company_type;
      return companyType === '123.net retail' || !companyType;
    },
    hasUsfWaiver(state) {
      const usfWaiverDate = state.company.usf_waiver_date;
      return usfWaiverDate != null;
    },
    validateContacts(state, getters) {
      const { general } = state.formData;
      const { contacts } = general;
      // validation
      if (!Array.isArray(contacts)) {
        return { status: false, reason: "You must fill out the contacts" };
      }
      if (contacts.length === 0) {
        return { status: false, reason: "No contacts entered!" };
      }

      const isNonEmptyString = (v) => typeof v === "string" && v.trim().length > 0;

      const normalizeRole = (role) => {
        if (!isNonEmptyString(role)) return "";
        return role
          .trim()
          .replace(/\s+/g, " ")
          .replace(/[–—−]/g, "-"); // normalize fancy dashes to "-"
      };

      const baseRequiredRoles = [
        "Order Notifications",
        "Local Contact",
        "Main Contact",
      ];
      if (!getters.isExistingCustomer) {
        baseRequiredRoles.push("Billing Contact");
        baseRequiredRoles.push("Portal Admin");
        if (!general.ap_address) {
          return { status: false, reason: `Billing Contact requires a company address` };
        }

        if (!general.ap_name) {
          return { status: false, reason: `Billing Contact requires a company name` };
        }

        if (!general.master_pin) {
          return { status: false, reason: `Billing Contact requires a PIN` };
        }
      }
      baseRequiredRoles.map(normalizeRole);

      const conditionalRequiredRoles = [];
      if (general.has_vendor === true) conditionalRequiredRoles.push(normalizeRole("IT Vendor"));
      if (general.has_pbx_vendor === true) {
        conditionalRequiredRoles.push(normalizeRole("PBX - Phone System Vendor"));
      }

      const requiredRoles = [...baseRequiredRoles, ...conditionalRequiredRoles];

      const roleRequirements = new Map([
        [
          normalizeRole("Billing Contact"),
          {
            fields: {
              // company: isNonEmptyString,
            },
            label: "Billing Contact",
          },
        ],
        [
          normalizeRole("IT Vendor"),
          {
            fields: {
              company: isNonEmptyString,
            },
            label: "IT Vendor",
          },
        ],
        [
          normalizeRole("PBX - Phone System Vendor"),
          {
            fields: {
              company: isNonEmptyString,
            },
            label: "PBX - Phone System Vendor",
          },
        ],
      ]);

      /** @type {Map<string, Array<{contact: Object, index: number}>>} */
      const contactsByRole = new Map();

      const addToRole = (role, contact, index) => {
        const key = normalizeRole(role);
        if (!key) return;
        const existing = contactsByRole.get(key);
        if (existing) {
          existing.push({ contact, index });
        } else {
          contactsByRole.set(key, [{ contact, index }]);
        }
      };

      for (let i = 0; i < contacts.length; i += 1) {
        const c = contacts[i];
        const rolesFromArray = Array.isArray(c.roles) ? c.roles : [];
        const rolesNormalized = rolesFromArray.map(normalizeRole).filter((r) => r.length > 0);
        const roleFromString = normalizeRole(c.role);
        const allRoles = new Set([...rolesNormalized, ...(roleFromString ? [roleFromString] : [])]);
        // add to index by role
        allRoles.forEach((r) => addToRole(r, c, i));
      }

      // Ensure at least one contact exists per required role
      for (let i = 0; i < requiredRoles.length; i += 1) {
        const role = requiredRoles[i];
        if (!contactsByRole.has(role)) {
          return { status: false, reason: `missing required role: "${role}"` };
        }
      }

      // Role-specific extra requirements:
      // For roles with requirements, at least ONE contact holding that role must satisfy the required fields.
      const validateRoleRequirements = (roleKey, entries) => {
        const req = roleRequirements.get(roleKey);
        if (!req) return null;

        const fieldNames = Object.keys(req.fields);

        // If any contact satisfies all requirements, the role passes.
        for (let i = 0; i < entries.length; i += 1) {
          const { contact } = entries[i];
          let allOk = true;

          for (let f = 0; f < fieldNames.length; f += 1) {
            const field = fieldNames[f];
            const validator = req.fields[field];
            if (!validator(contact[field])) {
              allOk = false;
              break;
            }
          }

          if (allOk) return null;
        }

        // None passed. Produce a useful error based on the "best" (least-bad) contact.
        let best = null; // { index, firstBadField, badCount }
        for (let i = 0; i < entries.length; i += 1) {
          const { contact, index } = entries[i];
          let badCount = 0;
          let firstBadField = null;

          for (let f = 0; f < fieldNames.length; f += 1) {
            const field = fieldNames[f];
            const validator = req.fields[field];
            if (!validator(contact[field])) {
              badCount += 1;
              if (!firstBadField) firstBadField = field;
            }
          }

          if (!best || badCount < best.badCount) {
            best = { index, firstBadField, badCount };
          }
        }

        if (best && best.firstBadField) {
          return `"${req.label}" requires a valid "${best.firstBadField}" [${best.index}]`;
        }

        return `"${req.label}" has unmet requirements`;
      };

      // Only validate requirements for roles that are actually required right now.
      for (let i = 0; i < requiredRoles.length; i += 1) {
        const role = requiredRoles[i];
        const entries = contactsByRole.get(role) || [];
        const reason = validateRoleRequirements(role, entries);
        if (reason) return { status: false, reason };
      }

      return { status: true };
    },
    canGoToTab: (state, getters) => (tab) => {
      const { general } = state.formData;
      const rddDone = general?.has_due_date === 'n' || general?.requested_due_date;

      // console.log(state.currentMainTab);
      // console.log(state.currentSubTab);
      // console.log(state.currentProductId);
      // console.log(state.products);

      // const product = state.formData[state.currentProductId] || {};
      if (state.currentMainTab === "products") {
        return { status: true };
      }

      if (state.currentMainTab === "additionalInfo") {
        if (tab === 'rdd') {
          return { status: true };
        }
        // TAX

        if (!rddDone) {
          return { status: false, reason: "If you have a requested due date you must enter that date" };
        }

        if (tab === 'tax_qs') {
          return { status: true };
        }

        if (tab === "usf_form") {
          return { status: true };
        }

        if (tab === "contacts") {
          return { status: true };
        }

        const contactValidation = getters.validateContacts;

        if (!contactValidation.status) {
          return contactValidation;
        }
      }
      return { status: true };
    },
  },

  modules: {
    Contacts,
  },
});
